export default __webpack_public_path__ + "media/images/Nouveau_logo-b50225537d729fe07b8aa7599a131a3b.png";